import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxMaskModule, IConfig } from 'ngx-mask';

import { MaterialModule } from '../material.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { CardComponent } from './thanks_page/card.component';
import { ChartComponent } from './chart/chart.component';
import { AlertDialog } from './alert/alert.dialog';
import { FilterControlComponent } from './filter-control/filter-control.component';
import { FilePickerComponent } from './file-picker/file-picker.compoent';
import { PaginationComponent } from './pagination/pagination.component';
import { SidePanelComponent } from './side-panel/side-panel.component';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { RouterModule } from '@angular/router';
import { AppHeadersComponent } from './app-headers/app-headers.component';
import { EventDialogComponent } from './event-dialog/event-dialog.component';
import { AccessManagementDialogComponent } from './access-management-dialog/access-management-dialog.component'
import { SelectBranchDialogComponent } from './select-branch-dialog/select-branch-dialog.component';
import { PdfViewComponent } from './pdf-view/pdf-view.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';


@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        FlexLayoutModule,
        MaterialModule,        
        NgxMaterialTimepickerModule,
        NgxMaskModule.forRoot(),
        MalihuScrollbarModule.forRoot(),
        PdfViewerModule
    ],
    declarations: [
        CardComponent,
        ChartComponent,
        AlertDialog,
        FilterControlComponent,
        FilePickerComponent,
        PaginationComponent,
        SidePanelComponent,
        AppHeadersComponent,
        EventDialogComponent,
        SelectBranchDialogComponent,
        AccessManagementDialogComponent,
        PdfViewComponent
    ],
    exports: [
        CardComponent,
        ChartComponent,
        AlertDialog,
        FilterControlComponent,
        FilePickerComponent,
        PaginationComponent,
        SidePanelComponent,
        AppHeadersComponent,
        PdfViewComponent
    ],
    providers: [
    ],
    entryComponents: [
        AlertDialog
    ],
})
export class CoreModule { }
